module.exports = __webpack_public_path__ + "img/reference-dangelo.9077025d.webp";